import { Box } from '@mui/material';
import { useState } from 'react';
import CreateNewMessageForm from 'components/forms/MessagingFactory/CreateNewMessageForm';
import MessagesHistoryList from 'components/MessagesHistoryList';

function MessagesHistoryView() {
  const [messagesActiveTab, setMessagesActiveTab] = useState(0);
  return (
    <Box
      sx={{
        flex: 10,
        flexDirection: { xs: 'column', lg: 'row' },
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <MessagesHistoryList
        messagesActiveTab={messagesActiveTab}
        setMessagesActiveTab={setMessagesActiveTab}
      />
      <CreateNewMessageForm />
    </Box>
  );
}

export default MessagesHistoryView;
